import { render } from "./VirtualRedTagScanQr.vue?vue&type=template&id=31613f4e&scoped=true&ts=true"
import script from "./VirtualRedTagScanQr.vue?vue&type=script&lang=ts"
export * from "./VirtualRedTagScanQr.vue?vue&type=script&lang=ts"

import "./VirtualRedTagScanQr.vue?vue&type=style&index=0&id=31613f4e&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31613f4e"]])

export default __exports__